import { AfterContentInit, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Client } from 'src/app/domain/client';
import { Configuration } from 'src/app/domain/configuration';
import { LimitCategory } from 'src/app/domain/limit-category';
import { ProductGroup } from 'src/app/domain/product-group';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ClientSelectionBoxDialog } from 'src/app/tools/ui/client-selection-box/client-selection-box';
import { ColorService } from 'src/app/tools/ui/color.service';
import { CopyConfBoxComponent } from 'src/app/tools/ui/copy-conf-box/copy-conf-box.component';
import { LimitCategoryBoxComponent } from 'src/app/tools/ui/limit-category-box/limit-category-box.component';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import * as _ from 'lodash'
import { CoreData } from 'src/app/tools/core-data/core-data';
import { EUserType } from 'src/app/domain/enum/user-type';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-config-list',
    templateUrl: './config-list.component.html',
    styleUrls: ['./config-list.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatButtonModule, PreventDoubleClickDirective, MatIconModule, MatChipsModule, CdkDropList, CdkDrag]
})
export class ConfigListComponent implements AfterContentInit {
    EUserType = EUserType;
    ConfigList: Configuration[] = [];
    FilteredConfigList: Configuration[] = [];
    SearchText: string = ''

    get User() {
        return this.coreData.User;
    }

    constructor(
        private configurationService: ConfigurationService,
        private router: Router,
        private snackBar: MatSnackBar,
        private coreData: CoreData,
        private dialog: MatDialog) {
        // this.getAllMyConfigurations();
    }

    ngAfterContentInit(): void {
        this.getAllConfiguration();
    }

    getAllMyConfigurations() {
        let newconf1 = new Configuration({ Code: 'conf00001', Name: 'Export Macro Sol Arcadis' });
        newconf1.ProductGroupList.push(...[
            new ProductGroup({ Code: 'code1', Name: 'SOL', TestGroupList: [] }),
            new ProductGroup({ Code: 'code2', Name: 'Eau', TestGroupList: [] })])
        this.ConfigList.push(newconf1)
        let newconf2 = new Configuration({ Code: 'conf00002', Name: 'ISDI CEMEX' });
        newconf2.ProductGroupList.push(...[
            new ProductGroup({ Code: 'code3', Name: 'SOL', TestGroupList: [] }),
            new ProductGroup({ Code: 'code4', Name: 'Eau ', TestGroupList: [] })])
        this.ConfigList.push(newconf2)
        let newconf3 = new Configuration({ Code: 'conf00003', Name: 'EIFFAGE' });
        newconf3.ProductGroupList.push(...[
            new ProductGroup({ Code: 'code5', Name: 'SOL', TestGroupList: [] })])
        this.ConfigList.push(newconf3)
        this.FilteredConfigList = this.ConfigList;
    }

    getAllConfiguration() {
        this.configurationService.GetMyConfigurationList().subscribe(x => {
            this.ConfigList = x;
            this.search();
        })
    }

    getProductListLabel(conf: Configuration) {
        return conf.ProductGroupList?.map(x => x.Code).concat()
    }

    getColor() {
        return ColorService.getRandomPastelColor();
    }

    search() {
        this.FilteredConfigList = this.ConfigList.filter(x => x.Name.toLowerCase().includes(this.SearchText.toLowerCase()))
    }

    IsThisConfMine(conf: Configuration) {
        return conf.CreatedByEmail === this.coreData.User?.Email
    }

    checkConfigurationIsDeletable(conf: Configuration) {

        if (!this.IsThisConfMine(conf)) {
            const m: ConfirmBoxModel = new ConfirmBoxModel();
            m.QuestionTitle = `Etes-vous sûr de vouloir supprimer cette configuration appartenant à ${conf.CreatedByEmail} ?`;
            const dialogRef = this.dialog.open(ConfirmBoxDialog, {
                data: m,
                width: '777px',
                disableClose: true
            });
            dialogRef.afterClosed().subscribe((result: boolean) => {
                if (result) {
                    this.deleteConf(conf)
                }
            });
        } else {
            this.deleteConf(conf)
        }
    }

    async deleteConf(conf: Configuration) {

        this.configurationService.delete(conf.Code).subscribe(x => {
            if (x) {
                _.remove(this.ConfigList, x => x.Code === conf.Code)
                this.search();
                NotificationManager.handleSuccess('Configuration supprimée !', this.snackBar);
            }
        })
    }

    // openConfigDialog(conf?: Configuration) {
    //     const dialogRef = this.dialog.open(ConfigBoxComponent, {
    //         data: conf ?? undefined,
    //         width: '777px',
    //         disableClose: true
    //     });

    //     dialogRef.afterClosed().subscribe((result: Configuration) => {
    //         if (result) {
    //             if (conf) {
    //                 this.ConfigList[this.ConfigList.indexOf(conf)] = result;
    //             }
    //             else
    //                 this.ConfigList.push(result)

    //             this.getAllConfiguration()
    //         }
    //     });
    // }
    openClientDialog(conf: Configuration) {
        const dialogRef = this.dialog.open(ClientSelectionBoxDialog, {
            data: { alreadyAssignedList: conf.ClientList },
            width: '1200px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Client[]) => {
            if (result) {
                conf.ClientList = result;
                this.configurationService.update(conf).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess('Client(s) ajouté(s) à la configuration', this.snackBar);
                    }
                });
            }
        });
    }

    openCategoryDialog(conf: Configuration, cat?: LimitCategory) {
        const dialogRef = this.dialog.open(LimitCategoryBoxComponent, {
            data: { configuration: conf, category: cat ?? undefined },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: LimitCategory) => {
            if (result === null) {
                _.remove(conf.LimitCategoryList, x => x.Code === cat?.Code)
            }
            if (result) {
                if (cat) {
                    conf.LimitCategoryList[conf.LimitCategoryList.indexOf(cat)] = result;
                } else {
                    conf.LimitCategoryList.push(result);
                }
                this.configurationService.update(conf).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess('Limite ajouté à la configuration', this.snackBar);
                    }
                });
            }
        });
    }

    openCopyConfDialog() {
        const dialogRef = this.dialog.open(CopyConfBoxComponent, {
            data: {},
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Configuration) => {
            if (result) {

                this.configurationService.copyFromMaster(result.Code).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess('Configuration copiée', this.snackBar);
                        this.getAllConfiguration()
                    }
                });
            }
        });
    }

    openConfirmDialogToDuplicateMaster(conf: Configuration) {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Etes-vous sûr de vouloir copier cette configuration ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (!result)
                return;

            this.configurationService.copyFromMaster(conf.Code).subscribe(x => {
                if (x) {
                    NotificationManager.handleSuccess('Configuration copiée', this.snackBar);
                    this.getAllConfiguration()
                }
            });
        });

    }

    drop(event: CdkDragDrop<string[]>, conf: Configuration) {
        if (event.previousIndex === event.currentIndex)
            return

        moveItemInArray(conf.LimitCategoryList, event.previousIndex, event.currentIndex);
        this.configurationService.update(conf).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Limites modifiées', this.snackBar);
            }
        });
    }

    navigateToConf(conf?: Configuration) {
        this.router.navigate([ENavigationRoute.Config, conf ? { configurationCode: conf.Code } : {}])
    }

    navigateToLimitConf(conf: Configuration, productGroup: ProductGroup) {
        this.router.navigate([ENavigationRoute.LimitSettings, { configurationCode: conf.Code, productGroupCode: productGroup.Code }])
    }
}
